var _defs, _circle, _circle2, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkippedCoin80(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 635 635",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6d738;}.cls-2{fill:#f3cc30;}.cls-3{fill:#edbd31;}.cls-4{fill:#f7db5e;}.cls-5{fill:url(#Unbenannter_Verlauf_186);}.cls-6{fill:url(#Unbenannter_Verlauf_186-2);}.cls-7{fill:url(#Unbenannter_Verlauf_186-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_186",
    x1: 639.15,
    y1: 622,
    x2: 415.75,
    y2: 495.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d49a34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4a900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_186-2",
    x1: 653.61,
    y1: 596.44,
    x2: 430.21,
    y2: 470.02,
    xlinkHref: "#Unbenannter_Verlauf_186"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_186-3",
    x1: 653.88,
    y1: 595.96,
    x2: 430.48,
    y2: 469.55,
    xlinkHref: "#Unbenannter_Verlauf_186"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 317.5,
    cy: 317.5,
    r: 317.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 317.5,
    cy: 317.5,
    r: 269.46
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M702,331a268.22,268.22,0,0,1,42.39,145.14c0,148.82-120.64,269.46-269.46,269.46a268.22,268.22,0,0,1-141-39.8A269.24,269.24,0,0,0,561,830.14c148.82,0,269.46-120.64,269.46-269.46A269.26,269.26,0,0,0,702,331Z",
    transform: "translate(-243.5 -243.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.74,585.66c0-131.37,106.5-237.87,237.87-237.87a237.46,237.46,0,0,1,188.55,92.87A237.77,237.77,0,0,0,558.9,321.35C427.53,321.35,321,427.84,321,559.21a236.84,236.84,0,0,0,49.31,145A236.82,236.82,0,0,1,338.74,585.66Z",
    transform: "translate(-243.5 -243.5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M556,495,519.7,531.35l-.41.42-.31.31-.06.06-.75.79c-.34.36-.68.71-1,1.07l-1,1.09c-1.12,1.27-2.2,2.57-3.22,3.9-.41.53-.81,1.06-1.21,1.6l-.59.81L510,543l-.55.83c-.38.58-.75,1.15-1.12,1.74-.15.26-.31.52-.47.77l-.51.85-.49.85q-1.72,3-3.16,6.09l-.39.86q-1.12,2.51-2.07,5.06l-.27.75a80.19,80.19,0,0,0-2.41,8.07c-.07.27-.13.53-.19.79l-.21.94c0,.17-.07.35-.11.53s-.12.53-.17.79l-.12.62c-.12.61-.22,1.21-.33,1.81-.07.42-.14.84-.2,1.26,0,.22-.07.45-.1.67-.18,1.3-.34,2.61-.46,3.92,0,.28-.06.55-.08.82,0,.54-.08,1.07-.11,1.6,0,.23,0,.46-.05.68s0,.59,0,.89l0,.67c0,.31,0,.63,0,.94a79.44,79.44,0,0,0,18.53,53.06l-59.69-61.63c-26.36-27.25-24.81-72.38,4.65-97.52,25.7-21.91,64-18,87.53,6.38Z",
    transform: "translate(-243.5 -243.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M662.11,590.66,567.17,685.6l-2.08-2.14a79.76,79.76,0,0,1,4.8-107.54L611,534.81c11.29-14.51,19.26-29,23.3-42.55,2.84-9.5,5.72-23.3-.23-37.1-2.78-6.48-6.59-10.59-6.05-11.07.69-.59,7.56,5.31,37,36.7l-.07.07A79.76,79.76,0,0,1,662.11,590.66Z",
    transform: "translate(-243.5 -243.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M603,532.46l-41.11,41.11a79.4,79.4,0,0,0-22.56,45.08c-4.29,30.14,16.56,54.22,13.24,56.53-1.48,1-7-2.73-24.2-22.34L517,641l-2.08-2.15a79.44,79.44,0,0,1-18.53-53.06c0-.31,0-.63,0-.94l0-.67c0-.3,0-.59,0-.89s0-.45.05-.68c0-.53.07-1.06.11-1.6,0-.27.05-.54.08-.82.12-1.31.28-2.62.46-3.92,0-.22.07-.45.1-.67.06-.42.13-.84.2-1.26.11-.6.21-1.2.33-1.81l.12-.62c0-.26.11-.53.17-.79s.07-.36.11-.53l.21-.94c.06-.26.12-.52.19-.79a80.19,80.19,0,0,1,2.41-8.07l.27-.75q.94-2.55,2.07-5.06l.39-.86q1.44-3.09,3.16-6.09l.49-.85.51-.85c.16-.25.32-.51.47-.77.37-.59.74-1.16,1.12-1.74L510,543l1.14-1.63.59-.81c.4-.54.8-1.07,1.21-1.6,1-1.33,2.1-2.63,3.22-3.9l1-1.09,1-1.07.75-.79.06-.06.31-.31.31-.31,95.06-95.06a79.13,79.13,0,0,1,11.44,16.41C634.9,474.58,625.6,503.44,603,532.46Z",
    transform: "translate(-243.5 -243.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedCoin80);
export default __webpack_public_path__ + "static/media/skipped-coin-80.5dc9a323688844ed4e0e1eab4f0eee44.svg";
export { ForwardRef as ReactComponent };